/*
|--------------------------------------------------------------------------
| PAYMENT GATEWAYS
|--------------------------------------------------------------------------
*/

export const PAYMENT_GATEWAYS = {
  RAZORPAY: "razorpay"
};


/*
|--------------------------------------------------------------------------
| PAYMENT STATUS
|--------------------------------------------------------------------------
*/

export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
  REFUNDED: "REFUNDED"
};


/*
|--------------------------------------------------------------------------
| PAYMENT STATUS LABELS
|--------------------------------------------------------------------------
*/

export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUS.PENDING]:
    "Pending",

  [PAYMENT_STATUS.PROCESSING]:
    "Processing",

  [PAYMENT_STATUS.SUCCESS]:
    "Success",

  [PAYMENT_STATUS.FAILED]:
    "Failed",

  [PAYMENT_STATUS.CANCELLED]:
    "Cancelled",

  [PAYMENT_STATUS.REFUNDED]:
    "Refunded"
};


/*
|--------------------------------------------------------------------------
| PAYMENT STATUS OPTIONS
|--------------------------------------------------------------------------
*/

export const PAYMENT_STATUS_OPTIONS = [
  {
    value: "",
    label: "All Statuses"
  },

  {
    value:
      PAYMENT_STATUS.PENDING,
    label: "Pending"
  },

  {
    value:
      PAYMENT_STATUS.PROCESSING,
    label: "Processing"
  },

  {
    value:
      PAYMENT_STATUS.SUCCESS,
    label: "Success"
  },

  {
    value:
      PAYMENT_STATUS.FAILED,
    label: "Failed"
  },

  {
    value:
      PAYMENT_STATUS.CANCELLED,
    label: "Cancelled"
  },

  {
    value:
      PAYMENT_STATUS.REFUNDED,
    label: "Refunded"
  }
];


/*
|--------------------------------------------------------------------------
| DEFAULT PAYMENT FILTERS
|--------------------------------------------------------------------------
*/

export const DEFAULT_PAYMENT_FILTERS = {
  status: "",
  offerId: ""
};
